import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { MdDashboard, MdViewList } from "react-icons/md";
import { Nav, Navbar, NavItem, NavLink as BSNavLink } from "reactstrap";
import SourceLink from "components/SourceLink";
import logo200ImageSvg from "assets/img/logo/side-logo-removebg-previews.png";
import bn from "utils/bemnames";

const navItems = [
  { to: "/", name: "dashboard", exact: true, Icon: MdDashboard },
  { to: "/issue/all", name: "Issue Master", exact: true, Icon: MdViewList },
];

const bem = bn.create("sidebar");

const Sidebar = () => {
  const navigate = useNavigate();

  return (
    <aside className={bem.b()}>
      <div className={bem.e("content")}>
        <Navbar className="d-flex nav-logo">
          <SourceLink className="navbar-brand d-flex">
            <img
              src={logo200ImageSvg}
              width="140"
              height="140"
              alt="logo"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            />
          </SourceLink>
        </Navbar>
        <Nav vertical>
          {navItems.map(({ to, name, exact, Icon }, index) => (
            <NavItem key={index} className={bem.e("nav-item")}>
              <BSNavLink
                id={`navItem-${name}-${index}`}
                className="text-uppercase"
                tag={NavLink}
                to={to}
                activeClassName="active"
                exact={exact}
              >
                <Icon className={bem.e("nav-item-icon")} />
                <span>{name}</span>
              </BSNavLink>
            </NavItem>
          ))}
        </Nav>
      </div>
    </aside>
  );
};

export default Sidebar;
